const reportPathname = (pathname: string) => pathname.replace(/\/+$/, '') + '/report'

export function cleanReportPath(pathname: string, access?: string): string {
  const path = reportPathname(pathname)
  return path + (access ? `?${new URLSearchParams({ acc: access })}` : '')
}

export function cleanReportUrl(shareLink: string | null, access?: string | null, baseOrigin = 'https://drive.reputifly.cloud'): string | null {
  if (!shareLink) return null
  const url = new URL(shareLink, baseOrigin)
  url.pathname = reportPathname(url.pathname)
  url.search = ''
  url.hash = ''
  if (access) url.searchParams.set('acc', access)
  return url.toString()
}
